import React from 'react';
import CodeDiffLine from '~/components/CodeDiffLine';
import CodeDiffHeader from '~/components/CodeDiffHeader';

interface TrashProps {
  packageInfo: object;
  filePath: string;
}

const Trash: React.FunctionComponent<TrashProps> = props => {
  const { name, commitHash } = props.packageInfo;
  const { filePath = '' } = props;

  //split Podfile#L5
  const splittedSelectedFilePath = filePath.split('#L');
  const file = splittedSelectedFilePath[0];
  const lineNumber = splittedSelectedFilePath[1] || '';

  return (
    <div>
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <CodeDiffHeader text={file} />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
        <CodeDiffLine type="highlight" lineNumber={lineNumber} text={`${name} ${commitHash}`} />
        <CodeDiffLine type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    </div>
  );
};

export default Trash;
